<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="closeDialog">
        <div class="row">
            <div class="col-md-6">
                <x-switch v-model="form.activate_pse"
                          style="margin-top: 0"
                          label="Firmar XML"></x-switch>
            </div>
            <div class="col-md-6 text-left" v-if="form.activate_pse">
                <a href="#" @click.prevent="validatePse">Validar conexión</a>
            </div>
            <div class="col-12">
                <x-switch v-model="form.activate_pse_ose"
                          :disabled="!form.activate_pse"
                          label="Enviar a OSE"></x-switch>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="closeDialog"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XSwitch from "../../../../components/Form/XSwitch";
import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";

export default {
    name: 'ClientConfigurationPse',
    components: {XModal, XButtonSubmit, XButtonCancel, XSwitch},
    props: ['showDialog', 'clientId'],
    data() {
        return {
            loading: false,
            title: null,
            resource: 'clients/configuration_pse',
            form: {},
            errors: {},
            action: ''
        }
    },
    methods: {
        initForm() {
            this.errors = {};
            this.form = {
                activate_pse: false,
                activate_pse_ose: false,
            };
            this.action = '';
            this.title = 'Configurar PSE'
        },
        async handleOpen() {
            this.loading = true;
            this.initForm();
            await this.getRecord();
            this.loading = false;
        },
        async getRecord() {
            await this.$http.get(`/${this.resource}/${this.clientId}`)
                .then(response => {
                    this.form = Object.assign({}, this.form, response.data);
                });
        },
        async onSubmit(index) {
            this.loading = true
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        // this.initForm();
                        // this.getRecord();
                        this.closeDialog();
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.records[index].errors = error.response.data;
                    } else {
                        console.log(error);
                    }
                })
            this.loading = false
        },
        async validatePse() {
            this.loading = true
            await this.$http.post(`/${this.resource}/validate_pse`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            this.loading = false
        },
        closeDialog() {
            this.$emit('update:showDialog', false);
        }
    }
}
</script>
